export enum SwiperNavigationTypesEnum {
  FRACTION = 'fraction',
  BULLETS = 'bullets',
  PROGRESS_BAR = 'progressbar',
  CUSTOM = 'custom',
}
